
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function PartyandItemWiseReport() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customerId, setCustomer] = useState('0');
    const { isAuthenticated, companyId, branchId, userId, permissions, token, username, logout, branchstate } = useAuth();
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };


    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    // Customer

    const [CustomerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [selectedCustomers, setCustomerType] = useState("0");

    const fetchCustomerType = async () => {
        try {

            const response = await fetchData('ReportApi', `/Customer/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(cmr => ({
                    value: cmr.MasterId,
                    label: cmr.Name
                }));
                setCustomerTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Raw Type:', error);
        }
    };
    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setCustomerType(selectedOption.value);
    };

    useEffect(() => {
        fetchCustomerType();
    }, []);
    // Item

    const [ItemTypeOptions, setItemTypeOptions] = useState([]);
    const [selectedItemType, setSelectedItemType] = useState("");
    const [selectedItem, setSelectedItem] = useState("0");

    const fetchItemType = async () => {
        try {

            const response = await fetchData('ItemApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(itm => ({
                    value: itm.id,
                    label: itm.name
                }));
                setItemTypeOptions(options);
            }

        } catch (error) {
            console.error('Error fetching  Item Type:', error);
        }
    };
    const handleItemTypeChange = (selectedOption) => {
        setSelectedItemType(selectedOption);
        setSelectedItem(selectedOption.value);
    };

    useEffect(() => {
        fetchItemType();
    }, []);

    const fetchTableData = async () => {
        setDataItem([])
        try {

            if (PartyandItemWise === "1") {

                const response = await fetchData('ReportApi', `/SalePartyWise/${companyId}/${selectedCustomers}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            }
            else if (PartyandItemWise === "2") {
                const response = await fetchData('ReportApi', `/SaleItemWise/${companyId}/${selectedItem}/${fromDate}/${toDate}`, token);

                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }

    };
    const [PartyandItemWise, setPartyandItemWise] = useState("1");
    const handlesetPartyandItemWiseChange = (event) => {
        setPartyandItemWise(event.target.value);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    const columnsCustomerWise = [
        { label: "Bill Date" },
        { label: "Bill Number" },
        { label: "Item Name" },
        { label: "Quantity" },
        { label: "Rate" },
        { label: "Taxable Amount" },
        { label: "GST Rate" },
        { label: "GST Amount" },
        { label: "Total Amount" },
    ];

    // const handleExportCustomerWiseExcel = () => {
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     // Function to add headers to the worksheet
    //     const addExcelHeader = (worksheet, title, columns) => {
    //         worksheet.push([`${title} | Generated On: ${formattedDateTime} By : ${username}`]);
    //         worksheet.push([]); // Empty row
    //         worksheet.push(columns.map((col) => col.label)); // Add column headers
    //     };

    //     // Function to prepare customer-wise data
    //     const exportCustomerWiseData = () => {
    //         const customerWiseSheet = [];
    //         const columns = columnsCustomerWise;

    //         addExcelHeader(customerWiseSheet, 'Customer Wise Data', columns);

    //         let previousCustomer = null;

    //         filteredDataItem.forEach((row) => {
    //             if (row.MasterName !== previousCustomer) {
    //                 customerWiseSheet.push([`Customer: ${row.MasterName}`]);
    //                 previousCustomer = row.MasterName;
    //             }

    //             customerWiseSheet.push([
    //                 row.BillDate,
    //                 row.BillNumber,
    //                 row.ItemName,
    //                 row.Quantity,
    //                 row.Rate.toFixed(2),
    //                 row.TaxableAmount.toFixed(2),
    //                 `${row.GSTRate}%`,
    //                 row.GSTAmount.toFixed(2),
    //                 row.TotalAmount.toFixed(2),
    //             ]);
    //         });

    //         customerWiseSheet.push([]); // Add an empty row at the end
    //         return customerWiseSheet;
    //     };

    //     // Generate customer-wise Excel data
    //     console.log("Exporting Customer Wise Data...");
    //     const customerWiseSheetData = exportCustomerWiseData();
    //     const wb = XLSX.utils.book_new();
    //     const customerSheet = XLSX.utils.aoa_to_sheet(customerWiseSheetData);

    //     XLSX.utils.book_append_sheet(wb, customerSheet, 'Customer Wise Report');
    //     XLSX.writeFile(wb, 'Customer_Wise_Report.xlsx');
    // };


    const handleExportCustomerWiseExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Customer Wise Report');

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        // 🔹 BORDER STYLE
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 HEADER (Merged & Centered)
        worksheet.mergeCells('A1:I1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `CustomerWise Sale Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        worksheet.addRow([]);
        // 🔹 COLUMN HEADERS
        const headerTitles = [
            'Bill Date',
            'Bill No',
            'Item Name',
            'Quantity',
            'Rate',
            'Taxable Amount',
            'GST Rate',
            'GST Amount',
            'Total Amount'
        ];

        const headerRow = worksheet.addRow(headerTitles);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '000000' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
            cell.border = thinBorder;
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        });

        // 🔹 DATA SECTION
        let previousCustomer = null;

        filteredDataItem.forEach((rowData) => {
            // Add Customer Header Row
            if (rowData.MasterName !== previousCustomer) {
                const customerRow = worksheet.addRow([`Customer: ${rowData.MasterName}`]);
                customerRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                customerRow.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4F81BD' }, // Blue header for customer
                };
                customerRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                worksheet.mergeCells(`A${customerRow.number}:I${customerRow.number}`);
                previousCustomer = rowData.MasterName;
            }

            // Add Item Row
            const dataRow = worksheet.addRow([
                rowData.BillDate,
                rowData.BillNumber,
                rowData.ItemName,
                rowData.Quantity,
                rowData.Rate?.toFixed(2),
                rowData.TaxableAmount?.toFixed(2),
                `${rowData.GSTRate}%`,
                rowData.GSTAmount?.toFixed(2),
                rowData.TotalAmount?.toFixed(2),
            ]);

            dataRow.eachCell((cell, colNumber) => {
                cell.border = thinBorder;

                if (colNumber >= 4) {
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });
        });

        // 🔹 COLUMN WIDTHS
        worksheet.columns = [
            { width: 14 }, // Bill Date
            { width: 12 }, // Bill No
            { width: 25 }, // Item Name
            { width: 10 }, // Quantity
            { width: 12 }, // Rate
            { width: 15 }, // Taxable
            { width: 10 }, // GST Rate
            { width: 12 }, // GST Amount
            { width: 15 }, // Total
        ];

        // 🔹 SAVE FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `Customer_Wise_Report_${formattedDateTime.replace(/[/: ]/g, '_')}.xlsx`);
    };


    const columnsItemWise = [
        { label: "Item Name" },
        { label: "Customer Name" },
        { label: "Bill Date" },
        { label: "Bill Number" },
        { label: "Quantity" },
        { label: "Rate" },
        { label: "Taxable Amount" },
        { label: "GST Rate" },
        { label: "GST Amount" },
        { label: "Total Amount" },
    ];



    const handleExportItemWiseExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Item Wise Report');

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        // 🔹 BORDER STYLE
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 HEADER (Merged & Centered)
        worksheet.mergeCells('A1:J1');
       const headerCell = worksheet.getCell('A1');
        headerCell.value = `ItemWise Sale Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        worksheet.addRow([]);

        // 🔹 COLUMN HEADERS
        const headerTitles = [
            'Item Name',
            'Customer Name',
            'Bill Date',
            'Bill No',
            'Quantity',
            'Rate',
            'Taxable Amount',
            'GST Rate',
            'GST Amount',
            'Total Amount'
        ];

        const headerRow = worksheet.addRow(headerTitles);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '000000' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'BADFDB' }, // Light green (header)
            };
            cell.border = thinBorder;
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        });

        // 🔹 DATA SECTION
        let previousItem = null;

        filteredDataItem.forEach((rowData) => {
            // Add Light Blue Item Header Row
            if (rowData.ItemName !== previousItem) {
                const itemRow = worksheet.addRow([`Item: ${rowData.ItemName}`]);
                itemRow.getCell(1).font = { bold: true, color: { argb: 'FF000000' } }; // Black text
                itemRow.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'F5F5F0' }, // 🔹 Light blue background
                };
                itemRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                worksheet.mergeCells(`A${itemRow.number}:J${itemRow.number}`);
                previousItem = rowData.ItemName;
            }

            // Add Data Row
            const dataRow = worksheet.addRow([
                rowData.ItemName,
                rowData.MasterName,
                rowData.BillDate,
                rowData.BillNumber,
                rowData.Quantity,
                rowData.Rate?.toFixed(2),
                rowData.TaxableAmount?.toFixed(2),
                `${rowData.GSTRate}%`,
                rowData.GSTAmount?.toFixed(2),
                rowData.TotalAmount?.toFixed(2),
            ]);

            dataRow.eachCell((cell, colNumber) => {
                cell.border = thinBorder;
                if (colNumber >= 5) {
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });
        });

        // 🔹 COLUMN WIDTHS
        worksheet.columns = [
            { width: 25 }, // Item Name
            { width: 25 }, // Customer Name
            { width: 14 }, // Bill Date
            { width: 12 }, // Bill No
            { width: 10 }, // Quantity
            { width: 12 }, // Rate
            { width: 15 }, // Taxable
            { width: 10 }, // GST Rate
            { width: 12 }, // GST Amount
            { width: 15 }, // Total
        ];

        // 🔹 SAVE FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `Item_Wise_Report_${formattedDateTime.replace(/[/: ]/g, '_')}.xlsx`);
    };


    const cellStyle = {
        borderBottom: '1px solid #ddd',
        color: 'black',
        fontWeight: 'bolder',
        padding: '7px',
        fontSize: '12px',
    };

    return (


        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '-1%' }}>
            <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                {/* Title */}
                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    SALES PARTY AND ITEM WISE REPORT
                </h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '32px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>

                <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '2px', marginTop: '1.25%' }}>
                    <div style={{ flex: '2', maxWidth: '150px', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                        <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="fromDate">
                            From Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date" value={fromDate} onChange={handleFromDateChange} style={{ fontSize: '12.5px' }}
                        />
                    </div>

                    <div style={{ flex: '2', maxWidth: '150px', marginLeft: '8px', marginBottom: '0', marginTop: '-15px' }}>
                        <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="toDate">
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date" value={toDate} onChange={handleToDateChange} style={{ fontSize: '12.5px' }}
                        />
                    </div>
                    <div className="flex justify-end items-center">
                        <label className="block tracking-wide text-gray-700 mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="PartyandItemWise"
                                value="1"
                                checked={PartyandItemWise === "1"} // This will check the "PartyWise" radio button by default
                                onChange={handlesetPartyandItemWiseChange}
                            />
                            <span style={{ color: 'blue', fontSize: '12px', marginLeft: '5px', cursor: 'pointer' }}>Party Wise</span>
                        </label>
                        <label className="block tracking-wide text-gray-700  mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="PartyandItemWise"
                                value="2"
                                checked={PartyandItemWise === "2"} // This will check the "ItemWise" radio button if it's selected
                                onChange={handlesetPartyandItemWiseChange}
                            />
                            <span style={{ color: 'brown', fontSize: '12px', marginLeft: '5px', cursor: 'pointer' }}>Item Wise</span>
                        </label>
                    </div>

                    <Button
                        style={{
                            background: "linear-gradient(to right, #A8A196,#A8A196)",
                            color: "black",
                            textTransform: "none",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                            maxHeight: "30px",
                            marginLeft: "15px",
                            marginTop: "2.10%",
                            borderRadius: "15px",
                        }}
                        onClick={fetchTableData}
                    >
                        <b style={{ color: 'white' }}>Refresh</b>
                    </Button>
                    {PartyandItemWise === "1" && (
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #3F4F44,#3F4F44)',
                                color: 'black',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                marginTop: '2.10%',
                                borderRadius: "15px",
                            }}
                            onClick={handleExportCustomerWiseExcel}
                        >
                            <b style={{ color: 'white' }}>Excel</b>
                        </Button>
                    )}
                    {PartyandItemWise === "2" && (
                        <Button
                            style={{
                                background: 'linear-gradient(to right, #3F4F44,#3F4F44)',
                                color: 'black',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                marginTop: '2.10%',
                                borderRadius: "15px",
                            }}
                            onClick={handleExportItemWiseExcel}
                        >
                            <b style={{ color: 'white' }}>Excel</b>
                        </Button>
                    )}
                </div>
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto', marginTop: '-15px' }}>
                {PartyandItemWise === "1" && (
                    <TableContainer component={Paper}>
                        <Table stickyHeader>
                            <TableHead sx={{ backgroundColor: '#484743', textTransform: 'uppercase' }}>
                                <TableRow>
                                    <TableCell colSpan={10} sx={{
                                        textTransform: 'uppercase',
                                        backgroundColor: '#484743',
                                        fontSize: '12px',
                                        color: 'whitesmoke',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        padding: '2px',
                                    }}>
                                        Customer Wise Data
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', fontWeight: 'bold' }}>BillDate</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', fontWeight: 'bold' }}>Bill Number</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', fontWeight: 'bold' }}>Item Name</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', fontWeight: 'bold' }}>Quantity</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', fontWeight: 'bold' }}>Rate</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', fontWeight: 'bold' }}>Taxable Amount</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', fontWeight: 'bold' }}>GST Rate</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', fontWeight: 'bold' }}>GST Amount</TableCell>
                                    <TableCell sx={{ padding: '2px', textTransform: 'uppercase', backgroundColor: '#6C6B68', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', fontWeight: 'bold' }}>Total Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Group data by customer */}
                                {Object.entries(
                                    filteredDataItem.reduce((acc, item) => {
                                        if (!acc[item.MasterName]) acc[item.MasterName] = [];
                                        acc[item.MasterName].push(item);
                                        return acc;
                                    }, {})
                                ).map(([customerName, items], customerIndex) => {
                                    // Calculate subtotals for the current customer
                                    const subtotalQty = items.reduce((sum, item) => sum + Number(item.Quantity || 0), 0).toFixed(2);
                                    const subtotalRate = items.reduce((sum, item) => sum + Number(item.Rate || 0), 0).toFixed(2);
                                    const subtotalTaxableAmount = items.reduce((sum, item) => sum + Number(item.TaxableAmount || 0), 0).toFixed(2);
                                    const subtotalGSTAmount = items.reduce((sum, item) => sum + Number(item.GSTAmount || 0), 0).toFixed(2);
                                    const subtotalTotalAmount = items.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2);

                                    return (
                                        <React.Fragment key={customerIndex}>
                                            {/* Customer Header */}
                                            <TableRow sx={{ backgroundColor: '#FAD0C4', color: 'black' }}>
                                                <TableCell colSpan={10} sx={{ fontWeight: 'bold', color: 'black', padding: '3px' }}>
                                                    {customerName}
                                                </TableCell>
                                            </TableRow>
                                            {/* Items for the Customer */}
                                            {items.map((data, index) => (
                                                <TableRow key={index} sx={{
                                                    padding: '3px',
                                                    height: '20px',
                                                    ":hover": { backgroundColor: '#C4DAD2' },
                                                    cursor: 'pointer',
                                                }}>
                                                    <TableCell sx={{ textAlign: 'left', padding: '5px' }}>{formatDate(data.BillDate)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '5px' }}>{data.BillNumber}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '5px' }}>{data.ItemName}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center', padding: '5px' }}>{data.Quantity}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.Rate.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.TaxableAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.GSTRate}%</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.GSTAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.TotalAmount.toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}
                                            {/* Subtotal Row */}
                                            <TableRow sx={{ backgroundColor: '#484743' }}>
                                                <TableCell colSpan={3} sx={{ textAlign: 'right', fontWeight: 'bold', padding: '3px' }}></TableCell>
                                                <TableCell sx={{ textAlign: 'center', fontWeight: 'bold', padding: '3px' }}>{subtotalQty}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '3px' }}>{subtotalRate}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '3px' }}>{subtotalTaxableAmount}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '3px' }} />
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '3px' }}>{subtotalGSTAmount}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '3px' }}>{subtotalTotalAmount}</TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>

                        </Table>
                    </TableContainer>
                )}

                {PartyandItemWise === "2" && (
                    <TableContainer component={Paper}>
                        <Table stickyHeader>
                            <TableHead sx={{
                                backgroundColor: '#484743',
                                textTransform: 'uppercase',
                            }}>
                                <TableRow>
                                    <TableCell colSpan={10} sx={{
                                        textTransform: 'uppercase',
                                        backgroundColor: '#484743',
                                        fontSize: '12px',
                                        color: 'whitesmoke',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        padding: '2px',
                                    }}>
                                        Item Wise Data
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold' }}>Item</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold' }}>Party</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold' }}>Bill Date</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold' }}>Bill Number</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold' }}>Quantity</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold' }}>Rate</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold' }}>Taxable Amount</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold' }}>GST Rate</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold' }}>GST Amount</TableCell>
                                    <TableCell sx={{ textTransform: 'uppercase', backgroundColor: '#6C6B68', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold' }}>Total Amount</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {/* Group data by item */}
                                {Object.entries(
                                    filteredDataItem.reduce((acc, item) => {
                                        if (!acc[item.ItemName]) acc[item.ItemName] = [];
                                        acc[item.ItemName].push(item);
                                        return acc;
                                    }, {})
                                ).map(([itemName, customers], itemIndex) => {
                                    // Calculate subtotals for the current item
                                    const subtotalQty = customers.reduce((sum, item) => sum + Number(item.Quantity || 0), 0).toFixed(2);
                                    const subtotalRate = customers.reduce((sum, item) => sum + Number(item.Rate || 0), 0).toFixed(2);
                                    const subtotalTaxableAmount = customers.reduce((sum, item) => sum + Number(item.TaxableAmount || 0), 0).toFixed(2);
                                    const subtotalGSTAmount = customers.reduce((sum, item) => sum + Number(item.GSTAmount || 0), 0).toFixed(2);
                                    const subtotalTotalAmount = customers.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2);

                                    return (
                                        <React.Fragment key={itemIndex}>
                                            {/* Item Header */}
                                            <TableRow sx={{ backgroundColor: '#FFE7CC', color: 'black' }}>
                                                <TableCell colSpan={10} sx={{ fontWeight: 'bold', color: 'black', padding: '5px' }}>
                                                    {itemName}
                                                </TableCell>
                                            </TableRow>
                                            {/* Customers under the Item */}
                                            {customers.map((data, index) => (
                                                <TableRow key={index} sx={{
                                                    padding: '3px',
                                                    height: '20px',
                                                    ":hover": { backgroundColor: '#E1D7C6' },
                                                    cursor: 'pointer',
                                                }}>
                                                    <TableCell />
                                                    <TableCell sx={{ textAlign: 'left', padding: '5px' }}>{data.MasterName}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '5px' }}>{formatDate(data.BillDate)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left', padding: '5px' }}>{data.BillNumber}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center', padding: '5px' }}>{data.Quantity}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.Rate.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.TaxableAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.GSTRate}%</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.GSTAmount.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', padding: '5px' }}>{data.TotalAmount.toFixed(2)}</TableCell>
                                                </TableRow>
                                            ))}
                                            {/* Subtotal Row */}
                                            <TableRow sx={{ backgroundColor: '#484743' }}>
                                                <TableCell colSpan={4} sx={{ textAlign: 'right', fontWeight: 'bold', padding: '5px' }}></TableCell>
                                                <TableCell sx={{ textAlign: 'center', fontWeight: 'bold', padding: '5px' }}>{subtotalQty}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '5px' }}>{subtotalRate}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '5px' }}>{subtotalTaxableAmount}</TableCell>
                                                <TableCell />
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '5px' }}>{subtotalGSTAmount}</TableCell>
                                                <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '5px' }}>{subtotalTotalAmount}</TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>


                )}
            </div>
        </div>
    );
}

export default PartyandItemWiseReport;
